module.exports = __webpack_public_path__ + "img/rewards_card.3b8e82ec.svg";